import React from 'react';
import { Globe } from 'lucide-react';
import { Button } from './ui/button';

export const LanguageToggle = ({ currentLang, onToggle }) => {
  return (
    <Button
      variant="outline"
      size="sm"
      onClick={onToggle}
      className="flex items-center gap-2 bg-white/90 hover:bg-white border-[#A0856E] text-[#2D1E13]"
    >
      <Globe className="h-4 w-4" />
      <span className="font-medium">{currentLang === 'en' ? 'عربي' : 'English'}</span>
    </Button>
  );
};
